import React, { useEffect } from "react";
import { useI18n } from "@/i18n/I18nProvider";
import LegalLayout from "@/components/LegalLayout";

export default function Terms() {
  const { t } = useI18n();
  useEffect(() => {
    document.title = `${t("pages.termsTitle")} · ${t("brand.name")}`;
  }, [t]);

  const sections = [
    { title: null, text: t("terms.intro") },
    ...Array.from({ length: 8 }, (_, i) => ({
      title: t(`terms.s${i + 1}Title`),
      text: t(`terms.s${i + 1}Text`),
    })),
  ];
  return <LegalLayout title={t("pages.termsTitle")} updated={t("pages.termsUpdated")} sections={sections} />;
}
